import FieldType from "../consts/datasourcemodule/FieldType";

class FieldColorHelper {

    static GetTagColor = (fieldType: number): string => {
        switch (fieldType) {
            case 0:
                return '#5A5A65';
            case FieldType.String:
                return '#00BBEE';
            case 8:
                return '#9A4AFF';
            case 3000:
                return '#0F7DFF';
        }
        return '#9A4AFF';
    }

    static GetTextColor = (fieldType: number): string => {
        switch (fieldType) {
            case 0:
                return '#9393A2';
            case FieldType.String:
                return 'white';
            case 8:
                return 'white';
            case 3000:
                return 'white';

        }
        return 'white';
    }
}

export default FieldColorHelper;